export const calendarEventStates = {
  DEFAULT: 'default',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export type CalendarEventState = (typeof calendarEventStates)[keyof typeof calendarEventStates];
